namespace RioERP.Inventory {
    export interface BookOutwardRow {
        Id?: number;
        BookId?: number;
        OpeningBalance?: number;
        TotalInward?: number;
        TotalOutward?: number;
        BalanceQuantity?: number;
        OutwardMonth?: string;
        Notes?: string;
        IsActive?: boolean;
        BookEBookType?: number;
        BookNoOfPages?: number;
        BookCost?: number;
        BookTaxCategoryId?: number;
        BookIsActive?: boolean;
        BookInsertUserId?: number;
        BookInsertDate?: string;
        BookUpdateUserId?: number;
        BookUpdateDate?: string;
        BookBookName?: string;
        BookIsbn?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace BookOutwardRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Notes';
        export const localTextPrefix = 'Inventory.BookOutward';
        export const deletePermission = 'Inventory:InventoryManagement:Modify';
        export const insertPermission = 'Inventory:InventoryManagement:Modify';
        export const readPermission = 'Inventory:InventoryManagement:View';
        export const updatePermission = 'Inventory:InventoryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            BookId = "BookId",
            OpeningBalance = "OpeningBalance",
            TotalInward = "TotalInward",
            TotalOutward = "TotalOutward",
            BalanceQuantity = "BalanceQuantity",
            OutwardMonth = "OutwardMonth",
            Notes = "Notes",
            IsActive = "IsActive",
            BookEBookType = "BookEBookType",
            BookNoOfPages = "BookNoOfPages",
            BookCost = "BookCost",
            BookTaxCategoryId = "BookTaxCategoryId",
            BookIsActive = "BookIsActive",
            BookInsertUserId = "BookInsertUserId",
            BookInsertDate = "BookInsertDate",
            BookUpdateUserId = "BookUpdateUserId",
            BookUpdateDate = "BookUpdateDate",
            BookBookName = "BookBookName",
            BookIsbn = "BookIsbn",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
